import { Log, Severity } from "@/models/Log";
import { defineStore } from "pinia";

interface State {
  logs: Log[];
}
export const useLoggingStore = defineStore("logging", {
  state: (): State => ({
    logs: [],
  }),
  getters: {
    Logs(): readonly Log[] {
      return this.logs || [];
    },
  },
  actions: {
    Info(details: { message: string; data?: object }): Promise<void> {
      this.AddLog({
        severity: Severity.Info,
        message: details.message,
        data: details.data ?? null,
        dateTime: new Date(),
      });
      return Promise.resolve();
    },
    Warn(details: { message: string; data?: object }): Promise<void> {
      this.AddLog({
        severity: Severity.Warning,
        message: details.message,
        data: details.data ?? null,
        dateTime: new Date(),
      });
      return Promise.resolve();
    },
    Success(details: { message: string; data?: object }): Promise<void> {
      this.AddLog({
        severity: Severity.Success,
        message: details.message,
        data: details.data ?? null,
        dateTime: new Date(),
      });
      return Promise.resolve();
    },
    Error(details: { message: string; data?: object }): Promise<void> {
      this.AddLog({
        severity: Severity.Error,
        message: details.message,
        data: details.data ?? null,
        dateTime: new Date(),
      });
      return Promise.resolve();
    },

    // Mutations
    AddLog(log: Log): void {
      this.logs.push(log);
    },
  },
});
